/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IPaymentCommunity } from 'app/shared/model/payment-community.model';

export interface ISchemeCommunity {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdate?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  scheme?: IPaymentScheme | null;
  community?: IPaymentCommunity | null;
}

export const defaultValue: Readonly<ISchemeCommunity> = {
  active: false,
};
